import { VERBS } from "../constant/permission";

export const transformAllVerb = (verbs) => {
  return verbs.includes(VERBS.ALL) ? [...Object.values(VERBS)] : verbs;
};
